import React, { useEffect } from "react";
import "../App.css";
// import { Filters } from "../features/filters/Filters";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrganization,
  selectOrganization,
} from "../features/organization/organizationSlice";
import { EventsTable } from "../features/events/EventsTable";
import { LineChart } from "../features/linechart/LineChart";
import { PieChart } from "../features/piechart/PieChart";
import { Maps } from "../features/maps/Maps";
import { EventsTableWWF } from "../features/events/EventsTableWWF";
import "./Home.css";

export default function Home() {
  const dispatch = useDispatch();
  const organization = useSelector(selectOrganization);

  useEffect(() => {
    dispatch(getOrganization());
  }, [dispatch]);

  let event_component =
    organization?.name === "CVGL" ? <EventsTable /> : <EventsTableWWF />;

  return (
    <div className="page">
      <div className="page__content">
        <div className="main-wrapper">
          <div
            className="main"
            style={{ marginLeft: "0px", marginTop: "16px" }}
          >
            <header className="header" style={styles.header}>
              <div className="container">
                <h2 className="header__title" style={styles.headerTitle}>
                  Dashboard
                </h2>
              </div>
            </header>
            <div className="content" style={styles.content}>
              <div className="container">
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="card" style={styles.card}>
                      <div className="card__content" style={styles.cardContent}>
                        <div className="card__body" style={styles.cardBody}>
                          <div className="chart" style={styles.chart}>
                            <LineChart />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="card" style={styles.card}>
                      <div className="card__content" style={styles.cardContent}>
                        <div className="card__body" style={styles.cardBody}>
                          <div className="chart" style={styles.chart}>
                            <PieChart />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="card" style={styles.card}>
                      <div className="card__content" style={styles.cardContent}>
                        <h3 className="card__title" style={styles.cardTitle}>
                          Maps
                        </h3>
                        <div
                          className="card__body"
                          style={{ ...styles.cardBody, height: "400px" }}
                        >
                          <Maps />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-12">
                    <Filters />
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-12">{event_component}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Styles object - only theme changes, no logic changes
const styles = {
  header: {
    background:
      "linear-gradient(135deg, #454545 0%, rgba(129, 129, 129, 0.95) 100%)",
    padding: "10px",
    color: "#ecf0f1",
    marginRight: "30px",
    marginLeft: "30px",
    borderRadius: "15px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
  },
  headerTitle: {
    margin: 0,
    fontSize: "24px",
    fontWeight: "bold",
    color: "#ffffff",
    textAlign: "center",
    letterSpacing: "0.5px",
  },
  content: {
    padding: "10px",
  },
  card: {
    marginBottom: "1px",
    background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
    borderRadius: "15px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    overflow: "hidden",
  },
  cardContent: {
    padding: "10px",
  },
  cardTitle: {
    margin: 0,
    color: "#454545",
    fontWeight: 600,
    fontSize: "18px",
  },
  cardBody: {
    marginTop: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "300px",
  },
  chart: {
    width: "100%",
    height: "100%",
  },
};
